import { render, staticRenderFns } from "./ReportMatrix.vue?vue&type=template&id=0d68c1e2&scoped=true&"
import script from "./ReportMatrix.vue?vue&type=script&lang=js&"
export * from "./ReportMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ReportMatrix.vue?vue&type=style&index=0&id=0d68c1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68c1e2",
  null
  
)

export default component.exports